"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcScheduleTitle = void 0;
const RepetitionType_1 = __importDefault(require("@opsbase/lib-time/RepetitionType"));
const calcRepetitionLabels_1 = __importDefault(require("./calcRepetitionLabels"));
function calcScheduleTitle(schedule, short = false) {
    const rType = schedule.repetitionType;
    if (rType === RepetitionType_1.default.NEVER) {
        return schedule.dueDate.format('Do MMM YYYY @ hh:mm A');
    }
    return (0, calcRepetitionLabels_1.default)(schedule, short)[rType];
}
exports.calcScheduleTitle = calcScheduleTitle;
exports.default = calcScheduleTitle;
